import { createContext, useContext, useMemo } from 'react';
import { makeMediaState, MediaState } from 'modules/Canvas/contexts/MediaProvider/MediaState/makeMediaState';

/**
 * Shared media state across the canvas
 */

export const MediaStateContext = createContext<MediaState>(null as unknown as MediaState);

export const MediaStateProvider: React.FC = ({ children }): JSX.Element => {
  const mediaState = useMemo(makeMediaState, []);

  return <MediaStateContext.Provider value={mediaState}>{children}</MediaStateContext.Provider>;
};

export function useMediaState(): MediaState {
  return useContext(MediaStateContext);
}
